// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uploadShortsContainer {
    border: 1px solid #273232;
    height: 70vh;
    width: 100%;
    margin-top: 5vh;
    margin-left: 2vw;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #0E1B1B;
    border-radius: 15px;
}

.uploadShortsTextContainer {
    border-bottom: 1px solid #273232;
    width: 97%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1.5vh;
    position: relative;
}

.uploadShortsText {
    color: white;
    font-size: 18px;
    font-weight: 600;
    font-family: 'Poppins', sans-serif;
}

.uploadActionContainer {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
    gap: 2vh;
}

.uploadActionContainerText {
    color: white;
    font-size: 16px;
    font-weight: 400;
    font-family: 'Poppins', sans-serif;
}

.uploadActionContainerBtn {
    padding: 12px 24px;
    border-radius: 8px;
    border: none;
    background-color: #5AAF9A;
    color: white;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    font-family: 'Poppins', sans-serif;
}

.uploadActionContainerNote {
    font-size: 12px;
    font-weight: 400;
    font-family: 'Poppins', sans-serif;
}

/* .videoPreviewContainer {
    width: 100%;
    height: calc(100% - 60px);
    align-items: center;
    padding: 20px;
    box-sizing: border-box;
    overflow: hidden;
    display: flex;
    justify-content: center;
    gap: 20px;
} */
.videoPreviewContainer {
    position: relative;
    width: 100%;
    height: 100%;
    align-items: center;
    padding: 15px;
    box-sizing: border-box;
    overflow: hidden;
    display: flex;
    justify-content: center;
    gap: 20px;
}

.videoUploadProgressContainer {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 10px;
    border-radius: 10px;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 15;
    background: rgba(0, 0, 0, 0.4);
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
}

.progressBarContainer {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
}

.progressBarLabel {
    color: white;
    font-size: 18px;
    font-weight: 500;
    font-family: 'Poppins', sans-serif;
    text-align: center;
}

.progressBarWrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    width: 300px;
}

.progressBar {
    width: 100%;
    height: 8px;
    background-color: rgba(255, 255, 255, 0.2);
    border-radius: 10px;
    overflow: hidden;
    position: relative;
}

.progressBarFill {
    height: 100%;
    background: linear-gradient(90deg, #5AAF9A, #7BC4B4);
    border-radius: 10px;
    transition: width 0.3s ease;
    position: relative;
}

.progressBarFill::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(90deg,
            transparent,
            rgba(255, 255, 255, 0.3),
            transparent);
    animation: shimmer 1.5s infinite;
}

@keyframes shimmer {
    0% {
        transform: translateX(-100%);
    }

    100% {
        transform: translateX(100%);
    }
}

.progressBarText {
    color: white;
    font-size: 16px;
    font-weight: 600;
    font-family: 'Poppins', sans-serif;
    text-align: center;
    min-width: 40px;
}

.videoWrapper {
    position: relative;
    width: 100%;
    height: 100%;
}

.videoPreview {
    width: 100%;
    height: 100%;
    object-fit: contain;
    border-radius: 10px;
    background-color: #000;
}

.closeIconContainer {
    position: absolute;
    top: 1%;
    right: 1%;
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 50%;
    padding: 5px;
    cursor: pointer;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
}

.closeIconContainer:hover {
    background-color: rgba(0, 0, 0, 0.7);
    transform: scale(1.1);
}

.videoPreviewActions {
    display: flex;
    gap: 20px;
    margin-top: 20px;
}

.removeVideoBtn,
.uploadVideoBtn {
    padding: 12px 24px;
    border-radius: 8px;
    border: none;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
}

.removeVideoBtn {
    background-color: #C15F5F;
    color: white;
}

.removeVideoBtn:hover {
    background-color: #a85151;
}

.uploadVideoBtn {
    background-color: #5AAF9A;
    color: white;
}

.nextButton {
    position: absolute;
    right: 20px;
    padding: 8px 20px;
    border-radius: 6px;
    border: none;
    background-color: #5AAF9A;
    color: white;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
}

.videoDescriptionContainer {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1vh;
    width: 100%;
    height: 100%;
}

.videoDescriptionTextarea {
    all: unset;
    width: 22vw;
    height: 15vh;
    background-color: #273232;
    border-radius: 10px;
    border: 1px solid #273232;
    box-sizing: border-box;
    padding: 10px;
    font-family: 'Poppins', sans-serif;
    color: white;
    font-size: 16px;
    word-wrap: break-word;
    overflow-wrap: break-word;
    white-space: normal;
    overflow-x: hidden;
    resize: vertical;
}

/* Search and Filter Row */
.searchAndFilterRow {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 95%;
    margin: 10px auto;
    position: sticky;
    top: 1%;
    z-index: 10;
}

.videoVoteSearchBar {
    flex: 1 1;
    padding: 10px 12px;
    border-radius: 8px;
    border: 1px solid #333;
    background: #1a1a1a;
    color: white;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    outline: none;
}

.videoVoteSearchBar::placeholder {
    color: #888;
}

.filterToggleBtn {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #5AAF9A;
    border: none;
    border-radius: 8px;
    padding: 10px;
    cursor: pointer;
    color: white;
    transition: background-color 0.2s;
}

.filterToggleBtn:hover {
    background-color: #4d9684;
}

/* Filter Dropdowns Row */
.filterDropdownsRow {
    display: flex;
    gap: 10px;
    width: 95%;
    margin: 0 auto 10px auto;
}

.filterDropdownGroup {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    gap: 4px;
    background-color: #1a1a1a;
    border: 1px solid #333;
    border-radius: 8px;
    padding: 8px 12px;
    position: relative;
}

.filterDropdownLabel {
    color: #888;
    font-size: 11px;
    font-family: 'Poppins', sans-serif;
}

.filterDropdownSelect {
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
}

.filterDropdownValue {
    color: white;
    font-size: 14px;
    font-weight: 500;
    font-family: 'Poppins', sans-serif;
}

.filterDropdownOptions {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background-color: #1a1a1a;
    border: 1px solid #333;
    border-radius: 8px;
    margin-top: 4px;
    z-index: 20;
    overflow: hidden;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
}

.filterDropdownOption {
    padding: 10px 12px;
    color: white;
    font-size: 14px;
    font-family: 'Poppins', sans-serif;
    cursor: pointer;
    transition: background-color 0.2s;
}

.filterDropdownOption:hover {
    background-color: #2a2a2a;
}

.filterDropdownOption.selected {
    background-color: #333;
}

.videoAttachVoteText {
    margin-top: 1vh;
    color: white;
    font-size: 16px;
    font-weight: 400;
    font-family: 'Poppins', sans-serif;
}

.videoVoteSelectContainer {
    height: 37vh;
    background-color: #273232;
    width: 22vw;
    border-radius: 10px;
    border: 1px solid #273232;
    overflow-y: auto;
    box-sizing: border-box;
    scrollbar-width: thin;
    scrollbar-color: #555 transparent;
    overflow-x: hidden;
}

.videoVoteSelectItem {
    padding: 8px 16px;
    display: flex;
    align-items: center;
    /* Prevent text from expanding container */
    min-width: 0;
}

.videoVoteSelectItemTextContainer {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 1vh
}

.videoVoteSelectItemText {
    color: white;
    font-size: 16px;
    font-weight: 400;
    font-family: 'Poppins', sans-serif;
    line-height: 1;
}

.videoVoteSelectItemText2 {
    color: #808080;
    font-size: 14px;
    font-weight: 400;
    font-family: 'Poppins', sans-serif;
    line-height: 1;
}

.videoVoteSelectItem.with-divider {
    border-bottom: 1px solid #757575;
}

.videoVoteSelectItem:hover {
    background-color: #1a2a2a;
    cursor: pointer;
}

.videoVoteSelectItem.selected {
    background-color: #1a2a2a;
}

.uploadShortsNextContainer {
    position: absolute;
    right: 8;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    display: flex;
    align-items: center;
    border-radius: 50%;
    padding: 2;
}

.videoVoteSelectItemCloseIcon {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);

}

@media (max-width: 1640px) {
    .uploadShortsText {
        font-size: 16px;
        font-weight: 600;
    }

    .uploadActionContainerText {
        font-size: 14px;
        font-weight: 400;
    }

    .uploadActionContainerBtn {
        padding: 12px 24px;
        border-radius: 8px;
        font-size: 16px;
    }

    .nextButton {
        padding: 7px 18px;
        border-radius: 6px;
        font-size: 13px;
    }

    .videoPreviewContainer {
        padding: 13px;
        gap: 18px;
    }

    .videoPreview {
        border-radius: 10px;
    }

    .videoDescriptionTextarea {
        border-radius: 10px;
        padding: 10px;
        font-size: 14px;
    }

    .videoVoteSearchBar {
        margin: 10px auto;
        padding: 8px;
        border-radius: 6px;
        font-size: 14px;
    }

    .videoVoteSelectItemText {
        font-size: 14px;
        font-weight: 400;
    }

    .videoVoteSelectItemText2 {
        font-size: 12px;
    }

    .uploadActionContainerNote {
        font-size: 11px;
    }

    .progressBarLabel {
        font-size: 16px;
    }

    .progressBarWrapper {
        width: 250px;
    }

    .progressBarText {
        font-size: 14px;
    }
}

@media (max-width: 1440px) {
    .uploadShortsText {
        font-size: 14px;
        font-weight: 500;
    }

    .uploadActionContainerText {
        font-size: 12px;
        font-weight: 400;
    }

    .uploadActionContainerBtn {
        padding: 10px 20px;
        border-radius: 6px;
        font-size: 14px;
    }

    .nextButton {
        padding: 6px 16px;
        border-radius: 6px;
        font-size: 12px;
    }

    .videoPreviewContainer {
        padding: 10px;
        gap: 15px;
    }

    .videoPreview {
        border-radius: 8px;
    }

    .videoDescriptionTextarea {
        border-radius: 9px;
        padding: 8px;
        font-size: 12px;
    }

    .videoVoteSearchBar {
        margin: 8px auto;
        padding: 6px;
        border-radius: 6px;
        font-size: 12px;
    }

    .videoVoteSelectItemText {
        font-size: 12px;
    }

    .videoVoteSelectItemText2 {
        font-size: 10px;
    }

    .uploadActionContainerNote {
        font-size: 10px;
    }

    .progressBarLabel {
        font-size: 14px;
    }

    .progressBarWrapper {
        width: 220px;
    }

    .progressBarText {
        font-size: 12px;
    }
}

@media (max-width: 1280px) {
    .uploadShortsText {
        font-size: 13px;
        font-weight: 450;
    }

    .uploadActionContainerText {
        font-size: 10px;
        font-weight: 400;
    }

    .uploadActionContainerBtn {
        padding: 8px 16px;
        border-radius: 6px;
        font-size: 12px;
    }

    .nextButton {
        padding: 5px 14px;
        border-radius: 5px;
        font-size: 11px;
    }

    .videoPreviewContainer {
        padding: 10px;
        gap: 15px;
    }

    .videoPreview {
        border-radius: 8px;
    }

    .videoDescriptionTextarea {
        border-radius: 8px;
        padding: 8px;
        font-size: 10px;
    }

    .videoVoteSearchBar {
        margin: 7px auto;
        padding: 5px;
        border-radius: 4px;
        font-size: 10px;
    }

    .videoVoteSelectItemText {
        font-size: 10px;
    }

    .videoVoteSelectItemText2 {
        font-size: 8px;
    }

    .uploadActionContainerNote {
        font-size: 9px;
    }

    .progressBarLabel {
        font-size: 12px;
    }

    .progressBarWrapper {
        width: 200px;
    }

    .progressBarText {
        font-size: 11px;
    }
}

@media (max-width: 1024px) {
    .uploadShortsText {
        font-size: 12px;
        font-weight: 400;
    }

    .uploadActionContainerText {
        font-size: 8px;
        font-weight: 400;
    }

    .uploadActionContainerBtn {
        padding: 6px 12px;
        border-radius: 4px;
        font-size: 10px;
    }

    .nextButton {
        padding: 4px 12px;
        border-radius: 4px;
        font-size: 10px;
    }

    .videoPreviewContainer {
        padding: 8px;
        gap: 10px;
    }

    .videoPreview {
        border-radius: 8px;
    }

    .videoDescriptionTextarea {
        border-radius: 8px;
        padding: 8px;
        font-size: 8px;
    }

    .videoVoteSearchBar {
        margin: 5px auto;
        padding: 4px;
        border-radius: 4px;
        font-size: 8px;
    }

    .videoVoteSelectItemText {
        font-size: 8px;
    }

    .videoVoteSelectItemText2 {
        font-size: 6px;
    }

    .uploadActionContainerNote {
        font-size: 7px;
    }

    .progressBarLabel {
        font-size: 10px;
    }

    .progressBarWrapper {
        width: 180px;
    }

    .progressBarText {
        font-size: 9px;
    }
}`, "",{"version":3,"sources":["webpack://./src/Components/UploadShorts/UploadShorts.css"],"names":[],"mappings":"AAGA;IACI,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;IAChC,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,QAAQ;AACZ;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,kCAAkC;AACtC;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,kCAAkC;AACtC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kCAAkC;AACtC;;AAEA;;;;;;;;;;GAUG;AACH;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,8BAA8B;IAC9B,0BAA0B;IAC1B,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,kCAAkC;IAClC,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,0CAA0C;IAC1C,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,oDAAoD;IACpD,mBAAmB;IACnB,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT;;;wBAGoB;IACpB,gCAAgC;AACpC;;AAEA;IACI;QACI,4BAA4B;IAChC;;IAEA;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,kCAAkC;IAClC,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,oCAAoC;IACpC,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;;AAEA;;IAEI,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,yBAAyB;IACzB,sBAAsB;IACtB,aAAa;IACb,kCAAkC;IAClC,YAAY;IACZ,eAAe;IACf,qBAAqB;IACrB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA,0BAA0B;AAC1B;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,UAAU;IACV,iBAAiB;IACjB,gBAAgB;IAChB,OAAO;IACP,WAAW;AACf;;AAEA;IACI,SAAO;IACP,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,kCAAkC;IAClC,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,YAAY;IACZ,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,yBAAyB;AACzB;IACI,aAAa;IACb,SAAS;IACT,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,kCAAkC;AACtC;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,yCAAyC;AAC7C;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,kCAAkC;IAClC,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,kCAAkC;AACtC;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;IAChB,sBAAsB;IACtB,qBAAqB;IACrB,iCAAiC;IACjC,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,0CAA0C;IAC1C,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,2BAA2B;IAC3B;AACJ;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,kCAAkC;IAClC,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kCAAkC;IAClC,cAAc;AAClB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,QAAQ;IACR,2BAA2B;IAC3B,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;;AAE/B;;AAEA;IACI;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;QAClB,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,SAAS;IACb;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;QACnB,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,YAAY;QACZ,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;QAClB,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,SAAS;IACb;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,YAAY;QACZ,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,SAAS;IACb;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,YAAY;QACZ,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,SAAS;IACb;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,YAAY;QACZ,cAAc;IAClB;;IAEA;QACI,gBAAgB;QAChB,YAAY;QACZ,kBAAkB;QAClB,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,cAAc;IAClB;AACJ","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\n\n\n.uploadShortsContainer {\n    border: 1px solid #273232;\n    height: 70vh;\n    width: 100%;\n    margin-top: 5vh;\n    margin-left: 2vw;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    background-color: #0E1B1B;\n    border-radius: 15px;\n}\n\n.uploadShortsTextContainer {\n    border-bottom: 1px solid #273232;\n    width: 97%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 1.5vh;\n    position: relative;\n}\n\n.uploadShortsText {\n    color: white;\n    font-size: 18px;\n    font-weight: 600;\n    font-family: 'Poppins', sans-serif;\n}\n\n.uploadActionContainer {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    height: 100%;\n    width: 100%;\n    gap: 2vh;\n}\n\n.uploadActionContainerText {\n    color: white;\n    font-size: 16px;\n    font-weight: 400;\n    font-family: 'Poppins', sans-serif;\n}\n\n.uploadActionContainerBtn {\n    padding: 12px 24px;\n    border-radius: 8px;\n    border: none;\n    background-color: #5AAF9A;\n    color: white;\n    font-size: 16px;\n    font-weight: 500;\n    cursor: pointer;\n    font-family: 'Poppins', sans-serif;\n}\n\n.uploadActionContainerNote {\n    font-size: 12px;\n    font-weight: 400;\n    font-family: 'Poppins', sans-serif;\n}\n\n/* .videoPreviewContainer {\n    width: 100%;\n    height: calc(100% - 60px);\n    align-items: center;\n    padding: 20px;\n    box-sizing: border-box;\n    overflow: hidden;\n    display: flex;\n    justify-content: center;\n    gap: 20px;\n} */\n.videoPreviewContainer {\n    position: relative;\n    width: 100%;\n    height: 100%;\n    align-items: center;\n    padding: 15px;\n    box-sizing: border-box;\n    overflow: hidden;\n    display: flex;\n    justify-content: center;\n    gap: 20px;\n}\n\n.videoUploadProgressContainer {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    padding: 10px;\n    border-radius: 10px;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 15;\n    background: rgba(0, 0, 0, 0.4);\n    backdrop-filter: blur(8px);\n    -webkit-backdrop-filter: blur(8px);\n}\n\n.progressBarContainer {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 20px;\n}\n\n.progressBarLabel {\n    color: white;\n    font-size: 18px;\n    font-weight: 500;\n    font-family: 'Poppins', sans-serif;\n    text-align: center;\n}\n\n.progressBarWrapper {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 10px;\n    width: 300px;\n}\n\n.progressBar {\n    width: 100%;\n    height: 8px;\n    background-color: rgba(255, 255, 255, 0.2);\n    border-radius: 10px;\n    overflow: hidden;\n    position: relative;\n}\n\n.progressBarFill {\n    height: 100%;\n    background: linear-gradient(90deg, #5AAF9A, #7BC4B4);\n    border-radius: 10px;\n    transition: width 0.3s ease;\n    position: relative;\n}\n\n.progressBarFill::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: linear-gradient(90deg,\n            transparent,\n            rgba(255, 255, 255, 0.3),\n            transparent);\n    animation: shimmer 1.5s infinite;\n}\n\n@keyframes shimmer {\n    0% {\n        transform: translateX(-100%);\n    }\n\n    100% {\n        transform: translateX(100%);\n    }\n}\n\n.progressBarText {\n    color: white;\n    font-size: 16px;\n    font-weight: 600;\n    font-family: 'Poppins', sans-serif;\n    text-align: center;\n    min-width: 40px;\n}\n\n.videoWrapper {\n    position: relative;\n    width: 100%;\n    height: 100%;\n}\n\n.videoPreview {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n    border-radius: 10px;\n    background-color: #000;\n}\n\n.closeIconContainer {\n    position: absolute;\n    top: 1%;\n    right: 1%;\n    background-color: rgba(0, 0, 0, 0.5);\n    border-radius: 50%;\n    padding: 5px;\n    cursor: pointer;\n    z-index: 10;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.2s ease;\n}\n\n.closeIconContainer:hover {\n    background-color: rgba(0, 0, 0, 0.7);\n    transform: scale(1.1);\n}\n\n.videoPreviewActions {\n    display: flex;\n    gap: 20px;\n    margin-top: 20px;\n}\n\n.removeVideoBtn,\n.uploadVideoBtn {\n    padding: 12px 24px;\n    border-radius: 8px;\n    border: none;\n    font-size: 16px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.removeVideoBtn {\n    background-color: #C15F5F;\n    color: white;\n}\n\n.removeVideoBtn:hover {\n    background-color: #a85151;\n}\n\n.uploadVideoBtn {\n    background-color: #5AAF9A;\n    color: white;\n}\n\n.nextButton {\n    position: absolute;\n    right: 20px;\n    padding: 8px 20px;\n    border-radius: 6px;\n    border: none;\n    background-color: #5AAF9A;\n    color: white;\n    font-size: 14px;\n    font-weight: 500;\n    cursor: pointer;\n}\n\n.videoDescriptionContainer {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 1vh;\n    width: 100%;\n    height: 100%;\n}\n\n.videoDescriptionTextarea {\n    all: unset;\n    width: 22vw;\n    height: 15vh;\n    background-color: #273232;\n    border-radius: 10px;\n    border: 1px solid #273232;\n    box-sizing: border-box;\n    padding: 10px;\n    font-family: 'Poppins', sans-serif;\n    color: white;\n    font-size: 16px;\n    word-wrap: break-word;\n    overflow-wrap: break-word;\n    white-space: normal;\n    overflow-x: hidden;\n    resize: vertical;\n}\n\n/* Search and Filter Row */\n.searchAndFilterRow {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    width: 95%;\n    margin: 10px auto;\n    position: sticky;\n    top: 1%;\n    z-index: 10;\n}\n\n.videoVoteSearchBar {\n    flex: 1;\n    padding: 10px 12px;\n    border-radius: 8px;\n    border: 1px solid #333;\n    background: #1a1a1a;\n    color: white;\n    font-family: 'Poppins', sans-serif;\n    font-size: 14px;\n    outline: none;\n}\n\n.videoVoteSearchBar::placeholder {\n    color: #888;\n}\n\n.filterToggleBtn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: #5AAF9A;\n    border: none;\n    border-radius: 8px;\n    padding: 10px;\n    cursor: pointer;\n    color: white;\n    transition: background-color 0.2s;\n}\n\n.filterToggleBtn:hover {\n    background-color: #4d9684;\n}\n\n/* Filter Dropdowns Row */\n.filterDropdownsRow {\n    display: flex;\n    gap: 10px;\n    width: 95%;\n    margin: 0 auto 10px auto;\n}\n\n.filterDropdownGroup {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    background-color: #1a1a1a;\n    border: 1px solid #333;\n    border-radius: 8px;\n    padding: 8px 12px;\n    position: relative;\n}\n\n.filterDropdownLabel {\n    color: #888;\n    font-size: 11px;\n    font-family: 'Poppins', sans-serif;\n}\n\n.filterDropdownSelect {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    cursor: pointer;\n}\n\n.filterDropdownValue {\n    color: white;\n    font-size: 14px;\n    font-weight: 500;\n    font-family: 'Poppins', sans-serif;\n}\n\n.filterDropdownOptions {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    right: 0;\n    background-color: #1a1a1a;\n    border: 1px solid #333;\n    border-radius: 8px;\n    margin-top: 4px;\n    z-index: 20;\n    overflow: hidden;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);\n}\n\n.filterDropdownOption {\n    padding: 10px 12px;\n    color: white;\n    font-size: 14px;\n    font-family: 'Poppins', sans-serif;\n    cursor: pointer;\n    transition: background-color 0.2s;\n}\n\n.filterDropdownOption:hover {\n    background-color: #2a2a2a;\n}\n\n.filterDropdownOption.selected {\n    background-color: #333;\n}\n\n.videoAttachVoteText {\n    margin-top: 1vh;\n    color: white;\n    font-size: 16px;\n    font-weight: 400;\n    font-family: 'Poppins', sans-serif;\n}\n\n.videoVoteSelectContainer {\n    height: 37vh;\n    background-color: #273232;\n    width: 22vw;\n    border-radius: 10px;\n    border: 1px solid #273232;\n    overflow-y: auto;\n    box-sizing: border-box;\n    scrollbar-width: thin;\n    scrollbar-color: #555 transparent;\n    overflow-x: hidden;\n}\n\n.videoVoteSelectItem {\n    padding: 8px 16px;\n    display: flex;\n    align-items: center;\n    /* Prevent text from expanding container */\n    min-width: 0;\n}\n\n.videoVoteSelectItemTextContainer {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n    gap: 1vh\n}\n\n.videoVoteSelectItemText {\n    color: white;\n    font-size: 16px;\n    font-weight: 400;\n    font-family: 'Poppins', sans-serif;\n    line-height: 1;\n}\n\n.videoVoteSelectItemText2 {\n    color: #808080;\n    font-size: 14px;\n    font-weight: 400;\n    font-family: 'Poppins', sans-serif;\n    line-height: 1;\n}\n\n.videoVoteSelectItem.with-divider {\n    border-bottom: 1px solid #757575;\n}\n\n.videoVoteSelectItem:hover {\n    background-color: #1a2a2a;\n    cursor: pointer;\n}\n\n.videoVoteSelectItem.selected {\n    background-color: #1a2a2a;\n}\n\n.uploadShortsNextContainer {\n    position: absolute;\n    right: 8;\n    top: 50%;\n    transform: translateY(-50%);\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    border-radius: 50%;\n    padding: 2;\n}\n\n.videoVoteSelectItemCloseIcon {\n    position: absolute;\n    right: 10px;\n    top: 50%;\n    transform: translateY(-50%);\n\n}\n\n@media (max-width: 1640px) {\n    .uploadShortsText {\n        font-size: 16px;\n        font-weight: 600;\n    }\n\n    .uploadActionContainerText {\n        font-size: 14px;\n        font-weight: 400;\n    }\n\n    .uploadActionContainerBtn {\n        padding: 12px 24px;\n        border-radius: 8px;\n        font-size: 16px;\n    }\n\n    .nextButton {\n        padding: 7px 18px;\n        border-radius: 6px;\n        font-size: 13px;\n    }\n\n    .videoPreviewContainer {\n        padding: 13px;\n        gap: 18px;\n    }\n\n    .videoPreview {\n        border-radius: 10px;\n    }\n\n    .videoDescriptionTextarea {\n        border-radius: 10px;\n        padding: 10px;\n        font-size: 14px;\n    }\n\n    .videoVoteSearchBar {\n        margin: 10px auto;\n        padding: 8px;\n        border-radius: 6px;\n        font-size: 14px;\n    }\n\n    .videoVoteSelectItemText {\n        font-size: 14px;\n        font-weight: 400;\n    }\n\n    .videoVoteSelectItemText2 {\n        font-size: 12px;\n    }\n\n    .uploadActionContainerNote {\n        font-size: 11px;\n    }\n\n    .progressBarLabel {\n        font-size: 16px;\n    }\n\n    .progressBarWrapper {\n        width: 250px;\n    }\n\n    .progressBarText {\n        font-size: 14px;\n    }\n}\n\n@media (max-width: 1440px) {\n    .uploadShortsText {\n        font-size: 14px;\n        font-weight: 500;\n    }\n\n    .uploadActionContainerText {\n        font-size: 12px;\n        font-weight: 400;\n    }\n\n    .uploadActionContainerBtn {\n        padding: 10px 20px;\n        border-radius: 6px;\n        font-size: 14px;\n    }\n\n    .nextButton {\n        padding: 6px 16px;\n        border-radius: 6px;\n        font-size: 12px;\n    }\n\n    .videoPreviewContainer {\n        padding: 10px;\n        gap: 15px;\n    }\n\n    .videoPreview {\n        border-radius: 8px;\n    }\n\n    .videoDescriptionTextarea {\n        border-radius: 9px;\n        padding: 8px;\n        font-size: 12px;\n    }\n\n    .videoVoteSearchBar {\n        margin: 8px auto;\n        padding: 6px;\n        border-radius: 6px;\n        font-size: 12px;\n    }\n\n    .videoVoteSelectItemText {\n        font-size: 12px;\n    }\n\n    .videoVoteSelectItemText2 {\n        font-size: 10px;\n    }\n\n    .uploadActionContainerNote {\n        font-size: 10px;\n    }\n\n    .progressBarLabel {\n        font-size: 14px;\n    }\n\n    .progressBarWrapper {\n        width: 220px;\n    }\n\n    .progressBarText {\n        font-size: 12px;\n    }\n}\n\n@media (max-width: 1280px) {\n    .uploadShortsText {\n        font-size: 13px;\n        font-weight: 450;\n    }\n\n    .uploadActionContainerText {\n        font-size: 10px;\n        font-weight: 400;\n    }\n\n    .uploadActionContainerBtn {\n        padding: 8px 16px;\n        border-radius: 6px;\n        font-size: 12px;\n    }\n\n    .nextButton {\n        padding: 5px 14px;\n        border-radius: 5px;\n        font-size: 11px;\n    }\n\n    .videoPreviewContainer {\n        padding: 10px;\n        gap: 15px;\n    }\n\n    .videoPreview {\n        border-radius: 8px;\n    }\n\n    .videoDescriptionTextarea {\n        border-radius: 8px;\n        padding: 8px;\n        font-size: 10px;\n    }\n\n    .videoVoteSearchBar {\n        margin: 7px auto;\n        padding: 5px;\n        border-radius: 4px;\n        font-size: 10px;\n    }\n\n    .videoVoteSelectItemText {\n        font-size: 10px;\n    }\n\n    .videoVoteSelectItemText2 {\n        font-size: 8px;\n    }\n\n    .uploadActionContainerNote {\n        font-size: 9px;\n    }\n\n    .progressBarLabel {\n        font-size: 12px;\n    }\n\n    .progressBarWrapper {\n        width: 200px;\n    }\n\n    .progressBarText {\n        font-size: 11px;\n    }\n}\n\n@media (max-width: 1024px) {\n    .uploadShortsText {\n        font-size: 12px;\n        font-weight: 400;\n    }\n\n    .uploadActionContainerText {\n        font-size: 8px;\n        font-weight: 400;\n    }\n\n    .uploadActionContainerBtn {\n        padding: 6px 12px;\n        border-radius: 4px;\n        font-size: 10px;\n    }\n\n    .nextButton {\n        padding: 4px 12px;\n        border-radius: 4px;\n        font-size: 10px;\n    }\n\n    .videoPreviewContainer {\n        padding: 8px;\n        gap: 10px;\n    }\n\n    .videoPreview {\n        border-radius: 8px;\n    }\n\n    .videoDescriptionTextarea {\n        border-radius: 8px;\n        padding: 8px;\n        font-size: 8px;\n    }\n\n    .videoVoteSearchBar {\n        margin: 5px auto;\n        padding: 4px;\n        border-radius: 4px;\n        font-size: 8px;\n    }\n\n    .videoVoteSelectItemText {\n        font-size: 8px;\n    }\n\n    .videoVoteSelectItemText2 {\n        font-size: 6px;\n    }\n\n    .uploadActionContainerNote {\n        font-size: 7px;\n    }\n\n    .progressBarLabel {\n        font-size: 10px;\n    }\n\n    .progressBarWrapper {\n        width: 180px;\n    }\n\n    .progressBarText {\n        font-size: 9px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
